
export const products = {
  'product.categories': 'קטגוריות מוצרים',
  'explore.solutions': 'גלה את מגוון פתרונות ה-AV המקצועיים שלנו',
  'view.video': 'צפה בסקירת המוצר בוידאו',
  'AV Over IP': 'AV על גבי IP',
  'ReAX Control': 'בקרת ReAX',
  'Meeting Room Solutions': 'פתרונות לחדרי ישיבות',
  'Converters/Scalers': 'ממירים/סקיילרים',
  'Audio Products': 'מוצרי אודיו',
  'HDMI Switchers': 'מתגי HDMI',
  'IPBaseT': 'IPBaseT',
  'HDBaseT Products': 'מוצרי HDBaseT',
  'Complete AV distribution solution with ultra-low latency': 'פתרון הפצת AV מלא עם השהיה נמוכה במיוחד',
  'Professional control system solutions': 'פתרונות מערכת בקרה מקצועיים',
  'Complete solutions for modern meeting spaces': 'פתרונות מלאים לחללי פגישות מודרניים',
  'Professional format conversion and scaling solutions': 'פתרונות המרת פורמט ושינוי גודל מקצועיים',
  'Professional audio processing and playback solutions': 'פתרונות עיבוד והשמעת אודיו מקצועיים',
  'Professional HDMI switching and distribution solutions': 'פתרונות מיתוג והפצת HDMI מקצועיים',
  'Advanced IP-based AV distribution platform': 'פלטפורמת הפצת AV מתקדמת מבוססת IP',
  'Professional HDBaseT distribution solutions': 'פתרונות הפצת HDBaseT מקצועיים',
  'group.not.found': 'הקבוצה לא נמצאה',
  'product.not.found': 'המוצר לא נמצא',
  'return.to.home': 'חזרה לדף הבית',
  'back.to.product.group': 'חזרה לקבוצת המוצרים',
  'overview': 'סקירה כללית',
  'full.description': 'תיאור מלא',
  'features': 'תכונות',
  'specifications': 'מפרט טכני',
};
